import { render, staticRenderFns } from "./jiZhongJingXue.vue?vue&type=template&id=9f4edf2a&scoped=true&"
import script from "./jiZhongJingXue.vue?vue&type=script&lang=js&"
export * from "./jiZhongJingXue.vue?vue&type=script&lang=js&"
import style0 from "./jiZhongJingXue.vue?vue&type=style&index=0&id=9f4edf2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4edf2a",
  null
  
)

export default component.exports